import styled from 'styled-components'

export const LoadingSpinner = styled.div<{ $size: string }>`
    margin-inline: auto;
    width: ${props => props.$size};
    height: ${props => props.$size};
    border-radius: 50%;
    border: 11.5px solid;
    border-color: var(--gray-3);
    border-right-color: var(--gray-8);
    animation: spinner 1s infinite linear;

    @keyframes spinner {
        to {
            transform: rotate(1turn);
        }
    }
`
